<template>
    <div class="load-progress-bar" :class="colorClass">
        <div class="progress-container">
            <div class="progress-midline"></div>
            <div
                class="progress-fill"
                :style="{ width: fillWidth + '%' }"
            ></div>
        </div>
        <span v-if="showPercent" class="percent-label">
            {{ Math.round(percent) }}%
        </span>
    </div>
</template>

<script>
import Cell from './cell';

export default {
    mixins: [Cell],

    computed: {
        percent() {
            return parseFloat(this.value) || 0;
        },

        showPercent() {
            return this.props?.showPercent !== false;
        },

        // Scale 0-200% to 0-100% width (so 100% = half bar, 200% = full bar)
        fillWidth() {
            const scaled = this.percent / 2;
            return Math.min(100, Math.max(0, scaled));
        },

        colorClass() {
            // <= 80% green, > 80% and <= 120% yellow, > 120% red
            if (this.percent <= 80) {
                return 'is-green';
            } else if (this.percent <= 120) {
                return 'is-yellow';
            } else {
                return 'is-red';
            }
        }
    }
};
</script>
